import { useWebTranslation } from "translations";
import { Typography } from "ui-kit/Typography";
import { AmountToPay } from "utils/insurance/getAmountToPay";
import { formatCurrency } from "utils/utils";
import styles from "./TotalRow.module.css";
import classNames from "classnames";
import { TypographyVariant } from "ui-kit/Typography/types";
import { BillingIntervalText } from "../BillingIntervalText";
import { MONTHLY_BILLING_INTERVAL } from "utils/insurance";
import { FlexRow } from "ui-kit/Layout/Flex";
import { isOrg } from "utils/site";

export const TotalRow = ({
  amountToPay,
  amountToPayYearly,
  billingInterval,
  textVariant = TypographyVariant.body1,
  orientation = "horizontal",
  hideLabel,
  className,
  hideDiscount,
}: {
  className?: string;
  orientation?: "vertical" | "horizontal";
  amountToPay: Omit<AmountToPay, "fees">;
  amountToPayYearly: Omit<AmountToPay, "fees">;
  billingInterval: number;
  textVariant?: TypographyVariant;
  hideLabel?: boolean;
  hideDiscount?: boolean;
}) => {
  const { t } = useWebTranslation();

  return (
    <div
      className={classNames(
        styles.container,
        orientation === "vertical" && styles.vertical,
        className
      )}
    >
      {hideLabel ? null : (
        <Typography variant="body2" color="grey500">
          {t("signup.total")}
        </Typography>
      )}
      <div className={styles.sum}>
        <div
          className={classNames(
            styles.amounts,
            orientation === "vertical" && styles.vertical
          )}
        >
          {amountToPay.old && !hideDiscount ? (
            <Typography variant="body3" color="grey400">
              <s>{formatCurrency(amountToPay.old)}</s>
            </Typography>
          ) : null}
          <Typography variant={textVariant}>
            <strong>{formatCurrency(amountToPay.new)}</strong>
          </Typography>
        </div>
        <BillingIntervalText color="grey500" />
        {isOrg("fra") && billingInterval === MONTHLY_BILLING_INTERVAL && (
          <>
            <FlexRow alignItems="baseline" style={{ gap: 8 }}>
              <Typography color="grey500" variant="body3">
                ({formatCurrency(amountToPayYearly.new)}
              </Typography>
              <Typography variant="body3" color="grey500">
                /{t("global.date.year")})
              </Typography>
            </FlexRow>
          </>
        )}
      </div>
    </div>
  );
};
